export default __webpack_public_path__ + "static/media/debate_16.daf459f1.JPG";